document.addEventListener('DOMContentLoaded', function () {
    const swiper = new Swiper('.featured-products-swiper__container', {
      slidesPerView: 1.8,
      spaceBetween: 10,
      freeMode: true, 
       scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
          },
      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
        firstSlideMessage: 'This is the first slide',
        lastSlideMessage: 'This is the last slide',
        paginationBulletMessage: 'Go to slide {{index}}',
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      mousewheel: {
        forceToAxis: true,
      },
      loop: true,
      navigation: {
        nextEl: '.featured-products-swiper__nav-next',
        prevEl: '.featured-products-swiper__nav-prev',
      },
      breakpoints: {
        0: {
          slidesPerView: 1.89,
          spaceBetween: 10,
         
        },
        400: {
          slidesPerView: 2,
          spaceBetween: 10,
          scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
          },
        }, 
        769: {
          slidesPerView: 3,
          spaceBetween: 15,
  
        },
        991: {
          slidesPerView: 4,
          spaceBetween: 23,
         
        },
      },
    });
  });